import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SmartBanner from 'react-smartbanner'
import _ from 'lodash'
import classNames from 'classnames/bind'
import styles from './styles.scss'
const cx = classNames.bind(styles)

try {
  require('react-smartbanner/dist/main.css')
} catch (e) {
  _.noop()
}

class NativeAppBanner extends Component {
  static propTypes = {
    track: PropTypes.func.isRequired,
    isSticky: PropTypes.bool,
    daysHidden: PropTypes.number,
    daysReminder: PropTypes.number,
    appStoreLanguage: PropTypes.string,
    title: PropTypes.string,
    author: PropTypes.string,
    button: PropTypes.string,
    store: PropTypes.object,
    price: PropTypes.object,
  }

  static defaultProps = {
    track: _.noop,
    isSticky: true,
    daysHidden: 3,
    daysReminder: 3,
    appStoreLanguage: 'us',
    title: 'Auction.com',
    author: 'Auction.com, LLC',
    button: 'VIEW',
  }

  componentDidMount() {
    const appBannerButton =
      document.getElementsByClassName('smartbanner-button')
    const isAndroid = window.navigator.userAgent.indexOf('Android') > -1

    if (isAndroid) {
      Array.from(appBannerButton).forEach(function (element) {
        element.addEventListener('click', () => {
          this.props.track('click', 'android')
        })
      })

      document.addEventListener('DOMContentLoaded', event => {
        this.props.track('load', 'android')
      })
    }
    if (this.props.isSticky) {
      setTimeout(() => {
        // This resets a margin setting react-smartbanner uses by default for the smart banner
        // We needed to reverse the effects of class 'smartbanner-show' to do scrolling/fixed header
        if (window.document.querySelector('html')?.style) {
          window.document.querySelector('html').style.margin = '0px'
        }
      }, 10)
    }
  }

  render() {
    return (
      <div data-elm-id='marketing_home_native_app_banner_section'>
        <div className={cx({ 'smart-banner-fix': this.props.isSticky })}>
          <SmartBanner
            daysHidden={this.props.daysHidden}
            daysReminder={this.props.daysReminder}
            appStoreLanguage={this.props.appStoreLanguage}
            title={this.props.title}
            author={this.props.author}
            button={this.props.button}
            store={this.props.store}
            price={this.props.price}
            // force={'ios'} // Uncomment for platform emulation
          />
        </div>
        {this.props.isSticky && <div className={cx('smart-banner-spacer')} />}
      </div>
    )
  }
}

export default NativeAppBanner
